import styled from "styled-components";

export const Wrap = styled.div`
  padding: 15px 10px;
  background: var(--grad-primary-n);
  border-radius: var(--root-br);
  color: white;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 480px),
    (max-width: 1199px) and (min-width: 992px) {
    flex-direction: column;
  }
`;
